import {Modal, Col, Timeline, Tag} from "antd";
import {useFormik} from "formik";
import moment from "moment";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import * as yup from "yup";
import * as Sentry from "@sentry/react";
import {useStore} from "../../../../hooks/useStore";
import stores from "../../../../store/stores";
import {CompanyFilter, SubCompanyFilter} from "../../../_defaultComponents/FilterComponents";

const ShiftCompanyUpdateModal = ({
    courierName,
    id,
    visibility,
    companyId,
    subCompanyId,
    onCancel,
    date,
    startTime,
    endTime
}) => {
    const {t} = useTranslation();
    const store = useStore();
    const [confirmLoading, setConfirmLoading] = useState();

    const formik = useFormik({
        initialValues: {companyId, subCompanyId},
        validationSchema: yup.object().shape({
            companyId: yup.string().required(),
            subCompanyId: yup.string().required()
        }),
        enableReinitialize: true,
        onSubmit: async values => {
            setConfirmLoading(true);
            try {
                const companyId = values.companyId;
                const subCompanyId = values.subCompanyId;

                await store.shiftStore.updateShiftCompanyAndSubCompany({
                    id,
                    companyId,
                    subCompanyId
                });
                onCancel(true);
            } catch (error) {
                Sentry.captureException(error);
            } finally {
                setConfirmLoading(false);
            }
        }
    });

    const {values, errors, touched, handleSubmit, setFieldValue} = formik;

    const onChangeCompany = value => {
        setFieldValue("companyId", value);
        setFieldValue("subCompanyId", "");
    };

    const onChangeSubCompany = value => {
        setFieldValue("subCompanyId", value);
    };

    return (
        <Modal
            title={courierName}
            visible={visibility}
            onCancel={() => {
                onCancel(false);
            }}
            onOk={handleSubmit}
            confirmLoading={confirmLoading}
            okText={t("modal.saveButton", {ns: "common"})}
            cancelText={t("modal.cancelButton2", {ns: "common"})}
        >
            <Col>
                <Tag style={{marginBottom: 20}} color="default">
                    {t("fields.date", {ns: "common"})}:{" "}
                    {!date ? "-" : moment(date).format("DD.MM.YYYY")}
                </Tag>
                <Timeline>
                    <Timeline.Item color="green">
                        {t("fields.shiftStartTime", {ns: "common"})}:{" "}
                        {!startTime ? "-" : moment(startTime).format("HH:mm")}
                    </Timeline.Item>
                    <Timeline.Item color="red" style={{paddingBottom: 0}}>
                        {t("fields.shiftEndTime", {ns: "common"})}:{" "}
                        {!endTime ? "-" : moment(endTime).format("HH:mm")}
                    </Timeline.Item>
                </Timeline>
            </Col>
            {stores.meStore.checkRole("notVisibleForCompanyUser") && (
                <Col>
                    <CompanyFilter
                        value={values.companyId}
                        onChange={onChangeCompany}
                        showPoolOption={true}
                    />
                </Col>
            )}
            {
                <Col>
                    <SubCompanyFilter
                        value={values.subCompanyId}
                        onChange={onChangeSubCompany}
                        company={values.companyId}
                        disabled={values.companyId === "pool"}
                        showAllOption={false}
                        initialCall={
                            stores.meStore.checkRole("isCompanyUser") ||
                            stores.meStore.orderPage?.filters.companies?.length > 0
                        }
                    />{" "}
                </Col>
            }
        </Modal>
    );
};

export default ShiftCompanyUpdateModal;
